export default {
  name: 'GameList',
  data() {
    return {
      show: false,
      info: null,
      showTable: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user || null;
    },
    loading() {
      return this.$store.state.loading || false;
    },
    gamesList() {
      return this.$store.state.game.gamesList || [];
    },
  },
  methods: {
    GetStatus(active) {
      return {
        color: active ? '#03ff03' : '#fd9797',
        label: active ? 'Активно' : 'Завершено',
      };
    },
    GetDate(dt) {
      const [year, month, day] = dt.split(' ')[0].split('-');
      return `${day}-${month}-${year}`;
    },
    GetPercentColor(percent) {
      return !percent || percent < 100 ? 'red--text' : 'green--text';
    },
    ShowTooltip(id) {
      this.info = id;
      setTimeout(() => {
        this.info = null;
      }, 2000);
    },
    ToggleTable(id) {
      if (id === this.showTable) {
        this.showTable = null;
      } else {
        this.showTable = id;
      }
    },
  },
  async mounted() {
    if (this.user) {
      await this.$store.dispatch('game/GetGamesList', {
        profile_id: this.user.profile_id,
      });
    }
  },
};
